import { PartialType, PickType } from '@nestjs/swagger';
import { SpBuilderNameUpdatableInterface } from '../interfaces/sp-builder-name-updatable.interface';
import { SpBuilderNameDto } from './sp-builder-name.dto';

export class SpBuilderNameUpdateDto
  extends PartialType(PickType(SpBuilderNameDto, ['active']))
  implements SpBuilderNameUpdatableInterface {}
